import IndividualBookmarks from 'app/routes/marketplace/bookmarks/individual';
import TeamBookmarks from 'app/routes/marketplace/bookmarks/team';
import { NotAuthorized } from "common/components/not-authorized";
import React, { useEffect } from 'react';
import { useLoaderData, useSearchParams } from 'react-router-dom';
import { useSession } from 'users/session/session-context';
import CompanyBookmarks from './company';
import { PageTab } from './tabs';

export default function Bookmarks() {
  const [activeTab, setActiveTab] = React.useState(PageTab.Individual);

  const tabFromUrl = useLoaderData();
  const [searchParams] = useSearchParams();
  const session = useSession();

  // Handle URL changes
  useEffect(() => {
    if (tabFromUrl) setActiveTab(tabFromUrl as PageTab);
  }, [searchParams, tabFromUrl]);

  if (!session.user?.companyEntityId) return <NotAuthorized />;

  return (
    <>
      {activeTab === PageTab.Individual && (
        <IndividualBookmarks activeTab={activeTab} />
      )}
      {activeTab === PageTab.Team && (
        <TeamBookmarks activeTab={activeTab} />
      )}
      {activeTab === PageTab.Company && (
        <CompanyBookmarks activeTab={activeTab} />
      )}
    </>
  );
}
